'use client';

import { useMount } from 'react-use';
import {
  fireVisitedBlogAuthor,
  fireVisitedBlogHomepage,
  fireVisitedBlogNavigation,
  fireVisitedBlogPost,
  fireVisitedBlogSearch,
} from '~/services/analytics/events/blog';
import Butter from '~/typings/services/buttercms';

export function BlogAnalyticsHomepage({}: {}) {
  useMount(() => {
    fireVisitedBlogHomepage();
  });

  return null;
}

export function BlogAnalyticsPost({ post }: { post: Butter.Post }) {
  useMount(() => {
    fireVisitedBlogPost(post);
  });

  return null;
}

export function BlogAnalyticsAuthor({
  authorFullName,
}: {
  authorFullName: string;
}) {
  useMount(() => {
    fireVisitedBlogAuthor(authorFullName);
  });

  return null;
}

export function BlogAnalyticsCategoryTag({
  category,
  tag,
}: {
  category: Butter.Category;
  tag: Butter.Tag;
}) {
  useMount(() => {
    fireVisitedBlogNavigation(category, tag);
  });

  return null;
}

export function BlogAnalyticsSearch({ searchTerm }: { searchTerm: string }) {
  useMount(() => {
    fireVisitedBlogSearch(searchTerm);
  });

  return null;
}
